<template>
  <div class="diseaseShow">
    <div class="diseaseShow_center">
      <div class="diseaseShow_nav" >
        <div class="nav_center" :class="{active:flagScroll}">
          <div class="header_title">
            <div class="imgBox">
              <img src="../../assets/images/home/u3277.png" alt="">
              <div>哮喘</div>
            </div>
            <div class="English">ASTHMA</div>
          </div>
          <div class="nav_list">
            <div @click="enter(1)" :class="{active:$route.query.id == 1 }" class="item_navList ">疾病百科</div>
            <div @click="enter(2)" :class="{active:$route.query.id == 2 }" class="item_navList">相关视频</div>
            <div @click="enter(3)" :class="{active:$route.query.id == 3 }" class="item_navList">相关文章</div>
            <div @click="enter(4)" :class="{active:$route.query.id == 4 }" class="item_navList">相关语音</div>
            <div @click="enter(5)" :class="{active:$route.query.id == 5 }" class="item_navList">相关问答</div>
            <div @click="enter(6)" :class="{active:$route.query.id == 6 }" class="item_navList">相关专家推荐</div>
          </div>
        </div>
      </div>
      <div class="twoRouteCenter">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import {_debounce} from '../../utils/index'
  export default {
    name: "Show",
    data(){
      return {
        flag:false,
        flagScroll:false, //
      }
    },
    methods:{
      // 跳转内容区
      enter(id){
        this.$router.push({path:'/diseaseShow/diseaseListTwo',query:{id:id?id:1}})
        // window.scrollTo({"behavior":"smooth","top":0});
      },
      // nav 滑动固定定位
      handleScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let offsetTop = document.querySelector('.nav_center').offsetTop
        let offsetBottom = document.querySelector('.footer_centre').offsetTop
        // console.log(scrollTop,offsetBottom);
        if (scrollTop > offsetTop+140) {
          this.flagScroll = true
        } else {
          this.flagScroll = false
        }
        if(scrollTop>offsetBottom-500){
          this.flagScroll = false
        }
      },
    },
    mounted() {
      this.enter()
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      // 解除绑定
      window.removeEventListener('scroll',this.handleScroll,false);
    }
  }
</script>
<style lang="stylus" scoped>
  .diseaseShow{
    width: 1200px
    margin 0 auto
    position relative
    .diseaseShow_center{
      margin-top 30px
      display flex
      .diseaseShow_nav{
        width: 140px
        margin-right 20px
        .nav_center{
          position relative
          &.active{
            width: 140px
            margin-right 20px
            position fixed
            top:0
          }
          .header_title{
            display flex
            align-items center
            justify-content center
            flex-direction column
            width: 140px;
            height: 93px;
            background #1083f8
            .imgBox{
              display flex
              align-items center
              >img{
                width: 41px;
                height: 29px;
                margin-right 10px
              }
              >div{
                font-weight: 700;
                font-style: normal;
                color: #FFFFFF;
                font-size: 24px;
              }
            }
            .English{
              font-weight: 700;
              font-style: normal;
              font-size: 20px;
              color: #FFFFFF;
              margin-top 10px
            }
          }
          .nav_list{
            .item_navList{
              text-align: center
              line-height 60px
              width: 140px;
              height: 60px;
              background #f2f2f2
              color: #333333;
              font-size 16px
              cursor: pointer
              &:hover{
                background #63a3fc
                color: #fff
              }
              &.active{
                background #63a3fc
                color: #fff
              }
            }
          }
        }

      }
      .twoRouteCenter{
        flex 1
        /*background deepskyblue*/
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/diseaseLibrary/Show.vue